import { render, staticRenderFns } from "./LogoutSuccess.vue?vue&type=template&id=6fb880b2&"
import script from "./LogoutSuccess.vue?vue&type=script&lang=js&"
export * from "./LogoutSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports